import { render } from "./OrderEditorForm.vue?vue&type=template&id=7827ddbe&scoped=true"
import script from "./OrderEditorForm.vue?vue&type=script&lang=js"
export * from "./OrderEditorForm.vue?vue&type=script&lang=js"

import "./OrderEditorForm.vue?vue&type=style&index=0&id=7827ddbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7827ddbe"]])

export default __exports__